module.exports = {
  ...require(`../../firebase-config.production`),
  appId: '1:104679062824:web:4c9368864e0a9615',
  measurementId: 'G-TN6MCJ55GF',
};
